/** CSS scale() — zoom > 1 iken içerik viewport genişliğini dolduracak şekilde artırılabilir */
export function computeVisualScale(
  zoom: number,
  baseW: number,
  viewportW: number,
): number {
  if (baseW < 1 || viewportW < 1) return zoom;
  let visualScale = zoom;
  if (zoom > 1 && baseW * zoom < viewportW - 0.5) {
    visualScale = (viewportW * zoom) / baseW;
  }
  return visualScale;
}

export type ContentTransform = {
  baseW: number;
  baseH: number;
  visualScale: number;
  dispW: number;
  dispH: number;
};

export function computeContentTransform(
  naturalW: number,
  naturalH: number,
  viewportW: number,
  viewportH: number,
  zoom: number,
): ContentTransform | null {
  if (naturalW < 1 || naturalH < 1 || viewportW < 2 || viewportH < 2) {
    return null;
  }
  const fit = Math.min(viewportW / naturalW, viewportH / naturalH);
  const baseW = Math.max(1, Math.round(naturalW * fit));
  const baseH = Math.max(1, Math.round(naturalH * fit));
  const visualScale = computeVisualScale(zoom, baseW, viewportW);
  return {
    baseW,
    baseH,
    visualScale,
    dispW: baseW * visualScale,
    dispH: baseH * visualScale,
  };
}
